import {
  GridColumnV2,
  GridUtilsV2,
  TwoButtonModalV2,
  WorkflowItem,
} from '@schenck/rotec-components';
import { Machine } from '../models/machine.model';
import { GridConfig } from '../models/grid-config.model';
import { DeviceFiles } from 'src/api/file.api';

export enum MachineKeys {
  name = 'name',
  gatewaySerial = 'gatewaySerial',
  tenantName = 'tenantName',
  isOnline = 'isOnline',
  cloudToDeviceMessageCount = 'cloudToDeviceMessageCount',
  firmwareVersion = 'firmwareVersion',
}

export const MACHINE_GRID_COLUMNS: GridColumnV2[] = [
  {
    key: MachineKeys.name,
    title: 'Name',
    sortable: true,
  },
  {
    key: MachineKeys.gatewaySerial,
    title: 'Gateway',
    sortable: true,
  },
  {
    key: MachineKeys.tenantName,
    title: 'Tenant',
    sortable: true,
  },
  {
    key: MachineKeys.cloudToDeviceMessageCount,
    title: 'C2D Messages',
    sortable: false,
  },
  {
    key: MachineKeys.firmwareVersion,
    title: 'Firmware Version',
    sortable: false,
  },
  {
    key: MachineKeys.isOnline,
    title: 'Online',
    sortable: false,
  },
] as GridColumnV2[];

export const MACHINE_GRID_CONFIG_DEFAULT: GridConfig = {
  displayedColumns: [
    MachineKeys.name,
    MachineKeys.gatewaySerial,
    MachineKeys.tenantName,
    MachineKeys.cloudToDeviceMessageCount,
    MachineKeys.firmwareVersion,
    MachineKeys.isOnline,
  ],
  columnOrder: [
    MachineKeys.name,
    MachineKeys.gatewaySerial,
    MachineKeys.tenantName,
    MachineKeys.cloudToDeviceMessageCount,
    MachineKeys.firmwareVersion,
    MachineKeys.isOnline,
  ],
  columnsWidths: {
    [MachineKeys.name]: 400,
    [MachineKeys.gatewaySerial]: 400,
    [MachineKeys.tenantName]: 400,
    [MachineKeys.cloudToDeviceMessageCount]: 200,
    [MachineKeys.firmwareVersion]: 200,
    [MachineKeys.isOnline]: 250,
  },
};

export const MACHINE_GRID_DEFAULT_FILTERS = {
  [MachineKeys.name]: GridUtilsV2.multiselectFilter,
  [MachineKeys.gatewaySerial]: GridUtilsV2.multiselectFilter,
  [MachineKeys.tenantName]: GridUtilsV2.multiselectFilter,
  [MachineKeys.isOnline]: GridUtilsV2.radioFilter,
};

export enum WorkflowStep {
  TENANT_AND_NAME = 'Tenant & Name',
  GATEWAY = 'Gateway',
}

export const ADD_EDIT_MACHINE_WORKFLOW_ITEMS: WorkflowItem[] = [
  { title: WorkflowStep.TENANT_AND_NAME, valid: false },
  { title: WorkflowStep.GATEWAY, valid: false },
];

export const MOCK_MACHINES: Machine[] = [
  {
    id: 'machine1',
    name: 'Machine1',
    cabVersion: 'cabVersion1',
    machineSerial: 'RERT2133',
    tenantId: '7bd40e72-9f3c-40d6-a698-e2066c2eab6b',
    isOnline: true,
  },
  {
    id: 'machine2',
    name: 'Machine2',
    cabVersion: 'cabVersion2',
    machineSerial: 'RERT2134',
    tenantId: '7bd40e72-9f3c-40d6-a698-e2066c2eab6b',
    isOnline: false,
  },
];

export const MOCK_DEVICE_FLES: DeviceFiles = {
  bugReportFiles: [
    {
      id: 'Machine1/BugReport/bugReport1.zip',
      name: 'bugReport1.zip',
      lastUpdated: '2024-04-18T04:55:13+00:00',
      contentType: 'application/octet-stream',
      size: 7573935,
      public: true,
    },
    {
      id: 'Machine1/BugReport/bugReport2.zip',
      name: 'bugReport2.zip',
      lastUpdated: '2024-04-18T04:56:59+00:00',
      contentType: 'application/octet-stream',
      size: 7573992,
      public: true,
    },
  ],
  supportBundleFiles: [
    {
      id: 'so-iothub-dev/Machine1-Edge/support-bundle-1.zip',
      name: 'support-bundle-1.zip',
      lastUpdated: '2023-06-30T12:49:00+00:00',
      contentType: 'application/zip',
      size: 1228189,
      public: true,
    },
    {
      id: 'so-iothub-dev/Machine2-Edge/support-bundle-2.zip',
      name: 'support-bundle-2.zip',
      lastUpdated: '2023-06-30T13:05:57+00:00',
      contentType: 'application/zip',
      size: 1261862,
      public: true,
    },
  ],
};

export const DELETE_DEVICE_FILES_MODAL: TwoButtonModalV2 = {
  title: '',
  text: '',
  summary: '',
  confirmText: 'COMMON_Delete',
  cancelText: 'COMMON_Cancel',
  warning: true,
  darkMode: true,
  width: '852px',
};
